import React from 'react';
import MarkerPlayer from './MarkerPlayer';
import {useEventContext} from 'providers/EventProvider';

const Players = () => {
  const {visiblePlayers} = useEventContext();

  return (
    <React.Fragment>
      {visiblePlayers
        .filter((p) => p.display.track.length > 0)
        .map((p) => (
          <MarkerPlayer key={p.deviceName} player={p} />
        ))}
    </React.Fragment>
  );
};

export default Players;
